<template>
  <div class="entry-exit-invoicing-details">
    <div class="row">
      <div class="sub-title">基本信息</div>
      <div class="base-info">
        <div class="base-info-item" v-for="(item, index) in baseInfoList" :key="index">
          <div class="base-info-item-label">{{ item.name }}：</div>
          <div class="base-info-item-content" :class="item.key === 'writeOffAmount' &&status > 30?'hign-content':''">
            <tool-tip v-bind="{ txtInfo: String(baseInfoObj[item.key]) }">
            </tool-tip>
            <!-- <img v-if="item.key === 'writeOffAmount' && status < 40" class="write-off" src="~assets/images/enter-exit/write-off-gray.png"> -->
            <img v-if="item.key === 'writeOffAmount'" @click="lookWriteOffRecords" class="write-off" src="~assets/images/enter-exit/write-off-hign.png">
          </div>
        </div>

        <el-form class="base-info-form" ref="baseInfoForm" :model="baseInfoForm" :rules="baseInfoRules">
          <el-form-item label="开票公司：" prop="invoiceCompanyName">
            <el-select class="white" 
              v-model="baseInfoForm.invoiceCompanyName" 
              placeholder="请选择"
              :disabled="status > 10"
              @change="changeInvoiceCompanyName"
            >
              <el-option v-for="(item, index) in bankAccountNumberList" :value="item.companyCode" :label="item.companyName" :key="index">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票类型：" prop="invoiceType">
            <el-select class="white" v-model="baseInfoForm.invoiceType" @change="changeInvoiceType" placeholder="请选择" :disabled="status > 10">
              <el-option v-for="(item, index) in invoiceTypeList" :value="item.id" :label="item.name" :key="index">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="税率：" prop="taxRate">
            <el-select class="white" v-model="baseInfoForm.taxRate" placeholder="请选择" :disabled="status > 10 || baseInfoForm.invoiceType === '75c13227b13cc02015c574b0d2e526a8'">
              <el-option v-for="(item, index) in taxRateList" :value="item.taxRate" :label="item.taxRate" :key="index">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="银行账户：" prop="invoiceBankAccount">
            <el-input class="white" v-model="baseInfoForm.invoiceBankAccount" disabled
              placeholder="请输入">
            </el-input>
          </el-form-item>
          <el-form-item label="发票备注：" prop="invoiceMemo">
            <el-input class="white" v-model="baseInfoForm.invoiceMemo" :disabled="status > 10"
              placeholder="请输入">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="row">
      <div class="sub-title sub-title-between">
        <span>发票明细</span>
        <span v-if="status === 10" class="generate-invoice-details" @click="openGenerateIvoiced">生成发票明细</span>
      </div>

      <div class="table invoice-table">
        <el-table 
          ref="invoiceTable" 
          :data="invoiceTable" 
          style="width: 100%" 
        >
          <el-table-column type="expand" width="30">
            <template slot-scope="props">
              <el-table 
                ref="subjectDetailsTable" 
                class="expand-colum-table" 
                :data="props.row.children" 
                style="width: 100%"
                :summary-method="getSummaries"
                show-summary
              >
                <el-table-column 
                  v-for="(item, index) in subjectDetailsTableTitle" 
                  :label="item.label" 
                  :prop="item.prop"
                  :width="item.width"
                  show-overflow-tooltip
                >
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>

          <el-table-column 
            v-for="(item, index) in invoiceTableTitle" :key="index" show-overflow-tooltip
            :prop="item.prop" :label="item.label"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'name'" class="name">
                <p>{{ scope.row.name }}</p>
              </div>
              <div v-if="item.prop === 'goodsQuantity'" class="nums" :class="(!scope.row.children || status > 10)?'nums-active':''">
                <p v-if="!scope.row.children || status > 10">
                  {{ scope.row.goodsQuantity }}
                </p>
                <el-input v-if="scope.row.children && status === 10" v-model="scope.row.goodsQuantity" class="white" placeholder="请输入"
                  @input="inputNums(scope.$index, scope.row.goodsQuantity)">
                </el-input>
              </div>
              <div v-if="item.prop === 'unitLocalPrice'" class="unit-price" :class="(!scope.row.children || status > 10)?'unit-price-active':''">
                <p v-if="!scope.row.children || status > 10">
                  {{ scope.row.unitLocalPrice }}
                </p>
                <el-input v-if="scope.row.children && status === 10" v-model="scope.row.unitLocalPrice" class="white" placeholder="请输入"
                  @input="inputUnitPrice(scope.$index, scope.row.unitLocalPrice)">
                </el-input>
              </div>
              <div v-if="item.prop === 'totalLocalPrice'" class="total-price" :class="(!scope.row.children || status > 10)?'total-price-active':''">
                <p v-if="!scope.row.children || status > 10">
                  {{ scope.row.totalLocalPrice }}
                </p>
                <el-input v-if="scope.row.children && status === 10" v-model="scope.row.totalLocalPrice" class="white" placeholder="请输入"
                  @input="inputTotalLocalPrice(scope.$index, scope.row.totalLocalPrice)">
                </el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="80">
            <template slot-scope="scope">
              <el-button :disabled="status !== 10" class="btn-text" type="text" @click="saveInvoicingDetails(scope.row)">保存</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    
    <div class="row">
      <div class="sub-title sub-title-between">
        <span>拖车明细</span>
        <span v-if="status === 10" class="generate-invoice-details" @click="importTrailer">拖车明细导入</span>
      </div>

      <div class="table trailer-table">
        <el-table ref="table" :data="trailerList" style="width: 100%" :cell-class-name="tableRowClassName">
          <el-table-column v-for="(item, index) in trailerTitleList" :key="index" :label="item.label" :prop="item.prop"
            :min-width="item.width" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="item.prop === 'type'">
                <p v-if="!scope.row.isMod">
                  {{ scope.row.type }}
                </p>
                <el-input v-else v-model="scope.row.type" class="white" placeholder="请输入">
                </el-input>
              </div>
              <div v-if="item.prop === 'plateNumber'">
                <p v-if="!scope.row.isMod">
                  {{ scope.row.plateNumber }}
                </p>
                <el-input v-else v-model="scope.row.plateNumber" class="white" placeholder="请输入">
                </el-input>
              </div>
              <div v-if="item.prop === 'origin'">
                <p v-if="!scope.row.isMod">
                  {{ scope.row.origin }}
                </p>
                <el-input v-else v-model="scope.row.origin" class="white" placeholder="请输入">
                </el-input>
              </div>
              <div v-if="item.prop === 'destination'">
                <p v-if="!scope.row.isMod">
                  {{ scope.row.destination }}
                </p>
                <el-input v-else v-model="scope.row.destination" class="white" placeholder="请输入">
                </el-input>
              </div>
              <div v-if="item.prop === 'goodsName'">
                <p v-if="!scope.row.isMod">
                  {{ scope.row.goodsName }}
                </p>
                <el-input v-else v-model="scope.row.goodsName" class="white" placeholder="请输入">
                </el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="status === 10">
            <template slot-scope="scope">
              <el-button v-if="scope.row.isMod" class="btn-text" type="text" @click="saveTrailer(scope.row)">保存</el-button>
              <el-button  class="btn-text" type="text" @click="delTrailer(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="add-account" @click="addTrailer" v-if="status === 10">
          <el-icon class="el-icon-plus"></el-icon>
          添加
        </div>
      </div>
    </div>

    <div class="row">
      <div class="sub-title">进出仓单信息</div>
      <div class="table order-table" :class="status === 10?'entry-exit-table':'entry-exit-table-details'">
        <el-table class="entry-table" v-if="status === 10" ref="invoiceTable" :data="entryTable" style="width: 100%">
          <el-table-column 
            v-for="(item, index) in entryTableTitle" 
            :key="index" 
            :prop="item.prop" 
            :label="item.label"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'name'" class="name">
                <p>{{ scope.row.name }}</p>
              </div>
              <div v-if="item.prop === 'serviceProcess'" class="service-process">
                <el-select class="white" v-model="scope.row.serviceProcess" placeholder="请选择">
                  <template slot="prefix">
                    <span v-if="(scope.$index === entryTable.length-1 && entryTable.length>1) || scope.row.serviceProcessType" class="ditto" @click.stop.self="dittoOrdown(scope.$index, scope.row, entryTable, 'serviceProcess', 'serviceProcessType')">同上</span>
                    <span v-if="scope.$index === 0 || !scope.row.serviceProcessType" class="down" @click.stop.self="dittoOrdown(scope.$index, scope.row, entryTable, 'serviceProcess', 'serviceProcessType')">同下</span>
                  </template>
                  <el-option 
                    v-for="(item, index) in serviceProcessList" 
                    :value="item.id" 
                    :label="item.name" 
                    :key="index">
                  </el-option>
                </el-select>
              </div>
              <div v-if="item.prop === 'depotLevelServices'" class="warehouse-services">
                <el-select class="white" v-model="scope.row.depotLevelServices" placeholder="请选择">
                  <template slot="prefix">
                    <span v-if="(scope.$index === entryTable.length-1 && entryTable.length>1) || scope.row.depotLevelServicesType" class="ditto" @click.stop.self="dittoOrdown(scope.$index, scope.row, entryTable, 'depotLevelServices', 'depotLevelServicesType')">同上</span>
                    <span v-if="scope.$index === 0 || !scope.row.depotLevelServicesType" class="down" @click.stop.self="dittoOrdown(scope.$index, scope.row, entryTable, 'depotLevelServices', 'depotLevelServicesType')">同下</span>
                  </template>
                  <el-option 
                    v-for="(item, index) in warehouseServicesList" 
                    :value="item.id" 
                    :label="item.name" 
                    :key="index">
                  </el-option>
                </el-select>
              </div>
              <div v-if="item.prop === 'warehouseCategory'" class="warehouse-category">
                <el-select class="white" v-model="scope.row.warehouseCategory" placeholder="请选择">
                  <template slot="prefix">
                    <span v-if="(scope.$index === entryTable.length-1 && entryTable.length>1) || scope.row.warehouseCategoryType" class="ditto" @click.stop.self="dittoOrdown(scope.$index, scope.row, entryTable, 'warehouseCategory', 'warehouseCategoryType')">同上</span>
                    <span v-if="scope.$index === 0 || !scope.row.warehouseCategoryType" class="down" @click.stop.self="dittoOrdown(scope.$index, scope.row, entryTable, 'warehouseCategory', 'warehouseCategoryType')">同下</span>
                  </template>
                  <el-option 
                    v-for="(item, index) in warehouseCategoryList" 
                    :value="item.id" 
                    :label="item.name" 
                    :key="index">
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
        </el-table>
        
        <el-table v-if="status === 10" ref="invoiceTable" :data="exitTable" style="width: 100%">
          <el-table-column 
            v-for="(item, index) in exitTableTitle" 
            :key="index" 
            :prop="item.prop" 
            :label="item.label"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'name'" class="name">
                <p>{{ scope.row.name }}</p>
              </div>
              <div v-if="item.prop === 'serviceProcess'" class="service-process">
                <el-select class="white" v-model="scope.row.serviceProcess" placeholder="请选择">
                  <template slot="prefix">
                    <span v-if="(scope.$index === exitTable.length-1 && exitTable.length>1) || scope.row.serviceProcessType" class="ditto" @click.stop.self="dittoOrdown(scope.$index, scope.row, exitTable, 'serviceProcess', 'serviceProcessType')">同上</span>
                    <span v-if="scope.$index === 0 || !scope.row.serviceProcessType" class="down" @click.stop.self="dittoOrdown(scope.$index, scope.row, exitTable, 'serviceProcess', 'serviceProcessType')">同下</span>
                  </template>
                  <el-option 
                    v-for="(item, index) in serviceProcessList" 
                    :value="item.id" 
                    :label="item.name" 
                    :key="index">
                  </el-option>
                </el-select>
              </div>
              <div v-if="item.prop === 'depotLevelServices'" class="warehouse-services">
                <el-select class="white" v-model="scope.row.depotLevelServices" placeholder="请选择">
                  <template slot="prefix">
                    <span v-if="(scope.$index === exitTable.length-1  && exitTable.length>1) || scope.row.depotLevelServicesType" class="ditto" @click.stop.self="dittoOrdown(scope.$index, scope.row, exitTable, 'depotLevelServices', 'depotLevelServicesType')">同上</span>
                    <span v-if="scope.$index === 0 || !scope.row.depotLevelServicesType" class="down" @click.stop.self="dittoOrdown(scope.$index, scope.row, exitTable, 'depotLevelServices', 'depotLevelServicesType')">同下</span>
                  </template>
                  <el-option 
                    v-for="(item, index) in warehouseServicesList" 
                    :value="item.id" 
                    :label="item.name" 
                    :key="index">
                  </el-option>
                </el-select>
              </div>
              <div v-if="item.prop === 'warehouseCategory'" class="warehouse-category">
                <el-select class="white" v-model="scope.row.warehouseCategory" placeholder="请选择">
                  <template slot="prefix">
                    <span v-if="(scope.$index === exitTable.length-1  && exitTable.length>1) || scope.row.warehouseCategoryType" class="ditto" @click.stop.self="dittoOrdown(scope.$index, scope.row, exitTable, 'warehouseCategory', 'warehouseCategoryType')">同上</span>
                    <span v-if="scope.$index === 0 || !scope.row.warehouseCategoryType" class="down" @click.stop.self="dittoOrdown(scope.$index, scope.row, exitTable, 'warehouseCategory', 'warehouseCategoryType')">同下</span>
                  </template>
                  <el-option 
                    v-for="(item, index) in warehouseCategoryList" 
                    :value="item.id" 
                    :label="item.name" 
                    :key="index">
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 详情展示表格 -->
        <el-table class="entry-table" v-if="status !== 10" ref="invoiceTable" :data="entryTable" style="width: 100%">
          <el-table-column 
            v-for="(item, index) in entryTableTitle" 
            :key="index" 
            :prop="item.prop" 
            :label="item.label"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
        <el-table v-if="status !== 10" ref="invoiceTable" :data="exitTable" style="width: 100%">
          <el-table-column 
            v-for="(item, index) in exitTableTitle" 
            :key="index" 
            :prop="item.prop" 
            :label="item.label"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
    </div>

    
    <div class="row">
      <div class="storage-title">
        <div class="storage-sub-title">存储信息</div>
        <el-form class="storage-form" ref="storageBaseInfoForm" :model="storageBaseInfoForm" :rules="stroageTable.length?storageBaseInfoRules:''">
          <el-form-item label="业务日期：" prop="businessDate">
            <el-date-picker
              v-model="storageBaseInfoForm.businessDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :disabled="status > 10"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="table order-table" :class="status === 10?'entry-exit-table':'entry-exit-table-details'">
        <el-table v-if="status === 10" ref="invoiceTable" :data="stroageTable" style="width: 100%">
          <el-table-column 
            v-for="(item, index) in entryTableTitle" 
            :key="index" 
            :prop="item.prop" 
            :label="item.label"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'name'" class="name">
                <p>{{ scope.row.name }}</p>
              </div>
              <div v-if="item.prop === 'serviceProcess'" class="service-process">
                <el-select class="white" v-model="scope.row.serviceProcess" placeholder="请选择">
                  <template slot="prefix">
                    <span v-if="(scope.$index === stroageTable.length-1 && stroageTable.length>1) || scope.row.serviceProcessType" class="ditto" @click.stop.self="dittoOrdown(scope.$index, scope.row, entryTable, 'serviceProcess', 'serviceProcessType')">同上</span>
                    <span v-if="scope.$index === 0 || !scope.row.serviceProcessType" class="down" @click.stop.self="dittoOrdown(scope.$index, scope.row, entryTable, 'serviceProcess', 'serviceProcessType')">同下</span>
                  </template>
                  <el-option 
                    v-for="(item, index) in serviceProcessList" 
                    :value="item.id" 
                    :label="item.name" 
                    :key="index">
                  </el-option>
                </el-select>
              </div>
              <div v-if="item.prop === 'depotLevelServices'" class="warehouse-services">
                <el-select class="white" v-model="scope.row.depotLevelServices" placeholder="请选择">
                  <template slot="prefix">
                    <span v-if="(scope.$index === stroageTable.length-1 && stroageTable.length>1) || scope.row.depotLevelServicesType" class="ditto" @click.stop.self="dittoOrdown(scope.$index, scope.row, stroageTable, 'depotLevelServices', 'depotLevelServicesType')">同上</span>
                    <span v-if="scope.$index === 0 || !scope.row.depotLevelServicesType" class="down" @click.stop.self="dittoOrdown(scope.$index, scope.row, stroageTable, 'depotLevelServices', 'depotLevelServicesType')">同下</span>
                  </template>
                  <el-option 
                    v-for="(item, index) in warehouseServicesList" 
                    :value="item.id" 
                    :label="item.name" 
                    :key="index">
                  </el-option>
                </el-select>
              </div>
              <div v-if="item.prop === 'warehouseCategory'" class="warehouse-category">
                <el-select class="white" v-model="scope.row.warehouseCategory" placeholder="请选择">
                  <template slot="prefix">
                    <span v-if="(scope.$index === stroageTable.length-1 && stroageTable.length>1) || scope.row.warehouseCategoryType" class="ditto" @click.stop.self="dittoOrdown(scope.$index, scope.row, stroageTable, 'warehouseCategory', 'warehouseCategoryType')">同上</span>
                    <span v-if="scope.$index === 0 || !scope.row.warehouseCategoryType" class="down" @click.stop.self="dittoOrdown(scope.$index, scope.row, stroageTable, 'warehouseCategory', 'warehouseCategoryType')">同下</span>
                  </template>
                  <el-option 
                    v-for="(item, index) in warehouseCategoryList" 
                    :value="item.id" 
                    :label="item.name" 
                    :key="index">
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 详情展示表格 -->
        <el-table v-if="status !== 10" ref="invoiceTable" :data="stroageTable" style="width: 100%">
          <el-table-column 
            v-for="(item, index) in entryTableTitle" 
            :key="index" 
            :prop="item.prop" 
            :label="item.label"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    
    <div class="footer">
      <el-button class="btn-white" @click="goBack">
        返回
      </el-button>
      <el-button
        v-if="status === 10"
        class="btn-blue"
        @click="invoicing('baseInfoForm', 'storageBaseInfoForm')"
        >开票</el-button
      >
      <el-button v-if="status === 30" class="btn-blue" @click="redChong">
        红冲
      </el-button>
      <el-button v-if="status === 20" class="btn-red" @click="delInvoice">删除</el-button>
      <el-button v-if="status === 10 || status === 70 || status === 80 " class="btn-red" @click="revoke">撤销</el-button>
    </div>

    
    <!-- 生成发票明细 -->
    <dialogTransfer
    v-if="generateInvoicedDialog"
    :title="title"
    :accountsType="accountsType"
    :generateInvoicedDialog="generateInvoicedDialog"
    :subjectTableTitle="subjectTableTitle"
    @onCloseGenerateInvoiced="onCloseGenerateInvoiced"
    @onSaveGenerateInvoiced="onSaveGenerateInvoiced"
    ></dialogTransfer>
    
    <!-- 核销记录 -->
    <el-dialog 
      class="write-off-dialog"
      title="核销记录" 
      top="18vh" 
      :visible.sync="writeOffRecordsDialog" 
      width="540px">
      <div class="border"></div>
      <div class="table">
        <el-table ref="table" :data="writeOffRecords" style="width: 100%">
          <el-table-column v-for="(item, index) in writeOffRecordsTitle" :key="index" :prop="item.prop"
            :label="item.label" :width="item.width" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeWriteOffRecordsDialog">取消</el-button>
        <el-button class="btn-blue" @click="closeWriteOffRecordsDialog">确认</el-button>
      </div>
    </el-dialog>

    <!-- 拖车明细导入 -->
    <el-dialog 
      class="down-dialog" 
      title="拖车明细导入" 
      top="20vh" 
      :visible.sync="importantTrailerDialog"
      width="420px" 
      :before-close="closeImportantTrailerDown">
      <div class="border"></div>
      <div>
        <div>
          <i class="el-icon-warning"></i>
          <span class="sub-title introduce">功能介绍</span>
        </div>
        <p class="tips">批量导入拖车明细费用</p>
      </div>
      <div class="down-tmp">
        <div class="sub-title">
          <span>下载导入模板</span>
          <span class="sub-tips">(点击下载)</span>
        </div>
        <el-button type="text" class="btn-text" @click="downTmp">拖车明细导入模板.xlsx</el-button>
      </div>
      <div>
        <p class="sub-title">明细导入</p>
        <el-upload
          v-if="isUpload"
          v-loading.fullscreen.lock="loading3"
          element-loading-text="文件上传中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          class="upload"
          ref="upload"
          action="#"
          :show-file-list="false"
          :auto-upload="true"
          :before-upload="uploadExcel"
        >
          <el-button slot="trigger" type="text" class="btn-text"
            >{{uploadTipsName}}</el-button
          >
        </el-upload>
        <div v-else class="upload-tips-container">
          <div class="upload-tips-name">
            {{uploadTipsName}}
            <i class="el-icon-error" @click="removeUploadTrailer"></i>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeImportantTrailerDown"
          >取消</el-button
        >
        <el-button class="btn-blue" @click="confirmTrailerDown"
          >确定</el-button
        >
      </div>
    </el-dialog>

    
    <!-- 是否发起红冲 -->
    <el-dialog 
      class="red-dialog" 
      title="红冲" 
      top="20vh" 
      :visible.sync="redChongDialog"
      width="420px" 
      :before-close="closeRedChong">
      <div class="border"></div>
      <div>
        <el-form class="red-chong-form" ref="redChongForm" :model="redChongForm">
          <el-form-item label="红冲发票号：" prop="redInvoiceNumber">
            <el-input class="white" v-model="redChongForm.redInvoiceNumber"
              placeholder="请输入">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeRedChong"
          >取消</el-button
        >
        <el-button class="btn-blue" @click="confirmRedChong"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { downLoadFile, formaTimeToMinute, modifyNetTitle } from "common/js/util";
import toolTip from '@/components/base/toolTip.vue'
import dialogTransfer from '@/components/base/inventory-reconciliation/dialog-transfer.vue'
import EntryExitInvoicing from "models/entry-exit-invoicing";
import EntryExitOrderMixins from "common/mixins/entry-exit-invoicing/entry-exit-order";
import EntryExitInvoicingBaseInfoMixins from "common/mixins/entry-exit-invoicing/base-info";
import EntryExitInvoicingInvoicingDetailsMixins from "common/mixins/entry-exit-invoicing/invoicing-details";
import { reject, resolve } from "core-js/fn/promise";
export default {
  mixins: [EntryExitInvoicingBaseInfoMixins, EntryExitInvoicingInvoicingDetailsMixins, EntryExitOrderMixins],
  components: {
    toolTip,
    dialogTransfer
  },

  data() {
    return {
      // 1：应收 2:应付
      accountsType: 1,
      // 详情id
      entryExitInvoicingId: null,
      // 开票状态
      status: 10,
      // 生成发票明细弹框开关
      generateInvoicedDialog: false,
      // 弹框标题名称
      title: '生成发票明细',
      // 科目明细表头
      subjectTableTitle: [
        { prop: 'feeName', label: '科目明细', width: ''},
        { prop: 'entryExitNumber', label: '进出仓编号/提单号', width: '180'},
        { prop: 'price', label: '金额', width: ''},
        { prop: 'localPrice', label: '本币金额', width: '120'}
      ],

      writeOffRecordsDialog: false,
      // 核销记录列表
      writeOffRecords: [],
      writeOffRecordsTitle: [
        { prop: 'time', label: '时间', width: '150' },
        { prop: 'info', label: '信息', width: '' },
      ],

      // 拖车列表
      trailerList: [],
      trailerTitleList: [
        { label: '种类', prop: 'type', width: '' },
        { label: '车牌', prop: 'plateNumber', width: '' },
        { label: '起运地', prop: 'origin', width: '' },
        { label: '目的地', prop: 'destination', width: '' },
        { label: '货物名称', prop: 'goodsName', width: '' }
      ],
      loading3: false,
      importantTrailerDialog: false,
      uploadTipsName: '点击导入',
      /* 拖车明细导入的流 */
      formData: null,
      /* 是否导入 */
      isUpload: true,
      
      redChongForm: {
        // 红冲发票号
        redInvoiceNumber: ''
      },
      redChongDialog: false
    }
  },

  created() {
    modifyNetTitle('进出仓应收开票详情')
    this.entryExitInvoicingId = Number(this.$route.query.entryExitInvoicingId)
    this.initInvoiceDetails()
  },

  methods: {
    initInvoiceDetails(type) {
      EntryExitInvoicing.getInvoiceDetails(this.entryExitInvoicingId).then(res => {
        if (res.success) {
          let { invoice, invoiceDetailList, 
            invoiceOrderDetailList, 
            invoiceCarItemList } = res.result
          this.status = invoice.status
          if (type === 'generate') {
            this.initInvoiceTable(invoiceDetailList)
          } else {
            this.initBaseInfo(invoice)
            this.initInvoiceTable(invoiceDetailList)
            this.initEntryExitTable(invoiceOrderDetailList, invoice.status, 'harvest')
            this.initTrailerTable(invoiceCarItemList)
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },

    initTrailerTable(invoiceCarItemList) {
      let arr = [];
      invoiceCarItemList.map(value => {
        let obj = {};
        obj.id = value.id;
        obj.invoiceId = value.invoiceId;
        obj.type = value.type;
        obj.plateNumber = value.plateNumber;
        obj.origin = value.origin;
        obj.destination = value.destination;
        obj.goodsName = value.goodsName;
        obj.isMod = false
        arr.push(obj);
      });
      this.trailerList = arr;
    },

    goBack() {
      this.$router.push({
        path: '/finance/entry-exit-invoicing/entry-exit-invoicing-list',
      })
    },
    
    /** 
     * @description 开票
    */
    invoicing(formName, formName2) {
      Promise.all([this.validateForm(formName), this.validateForm(formName2)]).then(() => {
        // 验证成功
        if (this.baseInfoObj.currency === 'USD') {
          let bankAccountNumberLObj = this.bankAccountNumberList.find(item => { return item.companyCode === this.baseInfoForm.invoiceCompanyName})
          if (bankAccountNumberLObj === undefined) return this.$message.error('公司基本信息不存在');
          if (this.baseInfoForm.invoiceCompanyName !== 'XY-TEST') {
            return this.$message.error('发票原币是美元时，开票公司必须是编码为XY-TEST的公司');
          } else {
            if (!bankAccountNumberLObj.status) {
              return this.$message.error('开票公司编码为XY-TEST的公司不能关闭');
            }
          }
        }
        if (this.invoiceTable.length === 0) return this.$message.error('请先生成发票明细');
        if (this.baseInfoForm.taxRate === 9) {
          if (this.trailerList.length === 0) {
            return this.$message.error('税率为9%时，拖车明细不能为空');
          } else {
            let isFalg = false
            this.trailerList.map(i => {
              if (i.isMod) {
                isFalg = true
              }
            })
            if (isFalg) return this.$message.error('拖车明细未保存');
          }
        }

        let invoiceCompanyName = this.baseInfoForm.invoiceCompanyName
        let invoiceType = this.baseInfoForm.invoiceType
        let bankName = this.baseInfoForm.invoiceBankName
        let bankAccount = this.baseInfoForm.invoiceBankAccount
        let taxRate = this.baseInfoForm.taxRate
        let invoiceMemo = this.baseInfoForm.invoiceMemo
        let businessDate = this.storageBaseInfoForm.businessDate
        
        let entryExitTable = [...this.entryTable, ...this.exitTable, ...this.stroageTable]
        let invoiceOrderDetailList = entryExitTable
        let data = {
          invoiceCompanyName,
          invoiceType,
          bankName,
          bankAccount,
          taxRate,
          invoiceMemo,
          businessDate,
          invoiceOrderDetailList
        }
        let isFlage = false
        entryExitTable.map(i => {
          if (!i.depotLevelServices) isFlage = true
        })
        if (isFlage) return this.$message.error('请选择仓库服务');
        EntryExitInvoicing.postPushInvoicing(this.entryExitInvoicingId, data).then(res => {
          if (res.success) {
            this.initInvoiceDetails()
          } else {
            this.$message.error(res.message);
          }
        });
      }).catch(() => {
        // 验证失败
        console.log('验证失败');
      })
    },

    /** 
     * @description 封装表单验证函数
    */
    validateForm(formName) {
      return new Promise((resolve, reject) => {
        this.$refs[formName].validate(valid => {
          if (valid) {
            resolve()
          } else {
            reject(new Error('错误!'))
          }
        })
      })
    },
    
    closeRedChong() {
      this.redChongForm.redInvoiceNumber = ''
      this.redChongDialog = false
    },

    confirmRedChong() {
      this.$confirm("是否发起红冲？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let data = {
          redInvoiceNumber: this.redChongForm.redInvoiceNumber
        }
        EntryExitInvoicing.postRedChongInvoicing(this.entryExitInvoicingId, data).then(res => {
          if (res.success) {
            this.initInvoiceDetails()
            this.closeRedChong()
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    /** 
     * @description 红冲
    */
    redChong() {
      this.redChongDialog = true
    },

    /** 
     * @description 撤销
    */
    revoke() {
      this.$confirm("是否发起撤销？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        EntryExitInvoicing.postCancelInvoicing(this.entryExitInvoicingId).then(res => {
          if (res.success) {
            this.goBack()
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    /** 
     * @description 删除发票
    */
    delInvoice() {
      this.$confirm("是否发起删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        EntryExitInvoicing.postDelInvoicing(this.entryExitInvoicingId).then(res => {
          if (res.success) {
            this.goBack()
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    
    openGenerateIvoiced() {
      this.generateInvoicedDialog = true
    },
    
    onCloseGenerateInvoiced() {
      this.generateInvoicedDialog = false
    },

    /** 
     * @description 生成发票明细
     * @param {array} editableTabs 拆分后的发票明细数据
    */
    onSaveGenerateInvoiced(editableTabs) {
      let arr = []
      editableTabs.map(i => {
        let obj = {}
        obj.goodsReceiptId = i.id
        obj.goodsReceiptName = i.goodsReceiptName
        obj.orderFeeDetailIdList = []
        i.subjectTableData.map(j => {
          obj.orderFeeDetailIdList.push(j.id)
        })
        arr.push(obj)
      })
      EntryExitInvoicing.postGenerateInvoicing(this.entryExitInvoicingId, arr).then(res => {
        if (res.success) {
          this.onCloseGenerateInvoiced()
          this.initInvoiceDetails('generate')
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /** 
     * @desc 同上/下方法
     * @param {number} index 当前下标
     * @param {object} row 当前行
     * @param {array} list 当前集合
     * @param {string} key 当前key
     * @param {string} type 当前类型
    */
    dittoOrdown(index, row, list, key, type) {
      if (list.length>1) {
        let item = null
        if (index === 0) {
          item = list[1]
        } else if (index === list.length-1) {
          item = list[list.length-2]
        } else {
          if (list.length>2) {
            if (row[type]) {
              item = list[index-1]
            } else {
              item = list[index+1]
            }
            row[type] = !row[type]
          }
        }
        row[key] = item[key]
      }
    },

    lookWriteOffRecords() {
      this.initWriteOffRecordsList()
    },
    
    /** 
     * @description 核销记录列表
    */
    initWriteOffRecordsList() {
      EntryExitInvoicing.getWriteOffRecordsList(this.entryExitInvoicingId).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.time = value.createdTime?formaTimeToMinute(value.createdTime):'';
            obj.info = value.memo;
            arr.push(obj);
          });
          this.writeOffRecords = arr;
          this.writeOffRecordsDialog = true
        }
      });
    },

    closeWriteOffRecordsDialog() {
      this.writeOffRecordsDialog = false
    },

    // 导入拖车明细
    importTrailer() {
      this.importantTrailerDialog = true
    },
    downTmp() {
      let url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/%E6%8B%96%E8%BD%A6%E6%98%8E%E7%BB%86%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      downLoadFile('拖车明细导入模板',url)
    },
    closeImportantTrailerDown() {
      this.removeUploadTrailer()
      this.importantTrailerDialog = false
    },
    confirmTrailerDown() {
      if (this.isUpload) {
        return this.$message.error("请导入文件");
      }
      EntryExitInvoicing
        .postTrailerExcel(this.formData)
        .then(res => {
          if (res.success) {
            this.$message.success("导入成功");
            this.initTrailerList()
            this.closeImportantTrailerDown()
          } else {
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning"
            }).then(() => {});
          }
        })
        .catch(res => {
          console.log(res);
          this.$message.error("导入失败");
        });
    },
    removeUploadTrailer() {
      this.formData = null
      this.uploadTipsName = '点击导入'
      this.isUpload = true
    },
    //导入Excel表格
    uploadExcel(file) {
      var formData = new FormData();
      formData.append("file", file);
      formData.append("invoiceId", this.entryExitInvoicingId);
      this.formData = formData
      this.uploadTipsName = file.name
      this.isUpload = false
      return false;
    },

    /** 
     * @description 拖车明细列表
    */
    initTrailerList() {
      let data = {
        invoiceId: this.entryExitInvoicingId
      }
      EntryExitInvoicing.getTrailerList(data).then(res => {
        if (res.success) {
          this.initTrailerTable(res.result)
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /** 
     * @description 添加拖车明细
    */
    addTrailer() {
      let obj = {
        id: '',
        invoiceId: '',
        type: '',
        plateNumber: '',
        origin: '',
        destination: '',
        goodsName: '',
        isMod: true
      }
      this.trailerList.push(obj)
    },

    /**
     * @description 保存拖车明细
     */
    saveTrailer(row) {
      let data = {
        type: row.type,
        plateNumber: row.plateNumber,
        origin: row.origin,
        destination: row.destination,
        goodsName: row.goodsName,
      }
      if (!row.type) return this.$message.error('请输入种类');
      if (!row.plateNumber) return this.$message.error('请输入车牌');
      if (!row.origin) return this.$message.error('请输入起运地');
      if (!row.destination) return this.$message.error('请输入目的地');
      if (!row.goodsName) return this.$message.error('请输入货物名称');
      EntryExitInvoicing.postAddTrailer(this.entryExitInvoicingId, data).then(res => {
        if (res.success) {
          this.$message.success("保存成功");
          this.initTrailerList()
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * @description 删除拖车明细
     */
    delTrailer(index, row) {
      this.$confirm("是否删除该明细？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "messageBox420",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white',
      }).then(() => {
        if (row.id) {
          let data = {
            carItemId: row.id,
            invoiceId: row.invoiceId
          }
          EntryExitInvoicing.postDelTrailer(data).then(res => {
            if (res.success) {
              this.$message.success("删除成功");
              this.initTrailerList()
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          this.trailerList.splice(index,1)
        }
      });
    },

    tableRowClassName({ row, column, columnIndex }) {
      if (!row.type && columnIndex === 0) {
        return "error-row";
      } else if (!row.plateNumber&& columnIndex === 1) {
        return "error-row";
      }else if (!row.origin&& columnIndex === 2) {
        return "error-row";
      }else if (!row.destination&& columnIndex === 3) {
        return "error-row";
      }else if (!row.goodsName&& columnIndex === 4) {
        return "error-row";
      }
    },

    changeInvoiceType(id) {
      if (id === '75c13227b13cc02015c574b0d2e526a8') this.baseInfoForm.taxRate = 0
    }
  }
}
</script>

<style lang='scss'>
.entry-exit-invoicing-details {
  .row {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 20px;
    .sub-title {
      height: 52px;
      line-height: 52px;
      border-bottom: 1px solid #eee;
      padding-left: 32px;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
    }
    .storage-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 64px;
      line-height: 64px;
      border-bottom: 1px solid #eee;
      padding-left: 32px;
      padding-right: 22px;
      .storage-sub-title {
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }
      
      .storage-form {
        .el-form-item {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 0px;
        }
      }
    }
    .sub-title-between {
      display: flex;
      justify-content: space-between;
      padding-right: 22px;
      .generate-invoice-details {
        cursor: pointer;
        font-weight: 400;
        font-size: 14px;
        color: #2E68EA;
        font-family: 'PingFang SC-Regular';
      }
    }
    .el-input.is-disabled .el-input__inner {
      background: #F5F7FA;
      color: #333333;
      font-family: 'PingFang SC-Regular';
      font-weight: 400;
      font-size: 14px;
    }
    .el-select.white .el-input__inner,
    .el-input.white .el-input__inner,
    .el-input.white .el-input__inner:hover {
      border-color: #EBEEF5;
    }
  }

  .row:nth-of-type(5) {
    margin-bottom: 0px;
    border-radius: 8px 8px 0px 0px;
  }

  // 基本信息
  .base-info {
    padding: 20px 32px 30px 32px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 16px;
    column-gap: 16px;
    .base-info-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-family: 'PingFang SC-Regular';
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #666666;
      .base-info-item-label {
        min-width: 40px;
      }
  
      .base-info-item-content {
        flex: 1;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .write-off {
          width: 14px;
          height: 14px;
          margin-left: 10px;
        }
      }
      .hign-content {
        color: #2E68EA;
      }
    }
    .base-info-form {
      grid-column: 1/-1;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      column-gap: 16px;
      row-gap: 20px;
      margin-top: 4px;
      .el-form-item {
        margin-bottom: 0px;
        .el-select,
        .el-input {
          width: 200px;
        }
        .el-form-item__error {
          left: 80px
        }
      }
      .el-form-item:nth-of-type(3) {
        .el-form-item__label {
          width: 80px;
        }
      }
      
      .el-form-item:nth-of-type(5) {
        .el-form-item__label {
          width: 80px;
        }
      }
    }
  }

  // 发票明细
  .invoice-table {
    padding: 20px 22px 14px 18px;
    .el-table .el-table__body-wrapper .el-table__body tr td .cell {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 44px;
    }
    .el-table .el-table__header-wrapper .el-table__header tr th:nth-of-type(2) .cell,
    .el-table .el-table__body-wrapper .el-table__body tr td:nth-of-type(2) .cell {
      padding-left: 0px;
    }
    .el-icon-arrow-right:before {
      content: "\E790";
    }
    .el-table__expand-icon--expanded {
      transform: rotate(180deg);
      color: #2E68EA;
    }
    .el-table__indent {
      padding-left: 3px!important;
    }
    .btn-text.is-disabled {
      color: #ccc;
    }
    .nums,
    .unit-price,
    .total-price,
    .bill-total-price {
      p {
        padding-left: 16px;
        color: #333333;
        font-family: 'PingFang SC-Regular';
        font-weight: 400;
        font-size: 14px;
      }
    }
    .nums-active,
    .unit-price-active,
    .total-price-active,
    .bill-total-active {
      p {
        padding-left: 0px;
      }
    }

    // 科目明细
    .el-table__expanded-cell {
      border: 0px;
    }
    .expand-colum-table {
      border-radius: 0px;
      border: 0px;
      .el-table__footer-wrapper .el-table__footer tr td .cell,
      .el-table__body-wrapper .el-table__body tr td .cell,
      .el-table__header-wrapper .el-table__header tr th .cell {
        height: 32px;
      }
      .el-table__footer-wrapper tbody td, .el-table__header-wrapper tbody td {
        background-color: white;
      }
      .el-table__footer-wrapper .el-table__footer tr td .cell {
        font-weight: 800;
        font-size: 14px;
        color: #333333;
        font-family: 'PingFang SC-Medium';
      }
    }
  }

  // 拖车明细
  .trailer-table {
    padding: 20px 22px 21px 18px;
    .el-table .el-table__body-wrapper .el-table__body tr td .cell {
      height: 44px;
      line-height: 44px;
    }
    .el-table .el-table__body-wrapper .el-table__body .close-row td .cell {
      color: #999999;
      font-family: 'PingFang SC-Regular';
      .el-button.mod-btn {
        color: #999999;
        font-size: 14px;
      }
    }
    .el-table .error-row .cell .el-input .el-input__inner,
    .el-table .error-row .cell .el-select .el-input__inner {
      border-color: #F56C6C;
    }
    .add-account {
      width: 100%;
      height: 36px;
      line-height: 36px;
      text-align: center;
      box-sizing: border-box;
      border: 1px dashed #2E68EA;
      font-family: 'PingFang SC-Regular';
      font-weight: 400;
      font-size: 14px;
      color: #2E68EA;
      cursor: pointer;
      margin: 10px 0px 0px 0px;
      .el-icon-plus {
        font-weight: 600;
      }
    }
  }

  // 进出仓单信息
  .entry-exit-table {
    padding: 20px 22px 14px 18px;
    .el-table .el-table__body-wrapper .el-table__body tr td .cell {
      height: 44px;
    }
  }
  .order-table {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    .service-process,
    .warehouse-services,
    .warehouse-category {
      .el-select {
        width: 80%;
        .el-input__inner {
          padding-left: 38px;
        }
        .el-input__prefix {
          width: 29px;
          height: 30px;
          line-height: 30px;
          left: 1px;
          top: 1px;
          background: #F5F7FA;
          border-right: 1px solid #EBEEF5;
          .ditto,
          .down {
            font-family: 'PingFang SC-Regular';
            font-weight: 400;
            font-size: 12px;
            cursor: pointer;
          }
          .ditto {
            color: #2E68EA;
          }
          .down {
            color: #22A979;
          }
        }
      }
    }
    .entry-table {
      margin-right: 20px;
    }
    .el-table {
      max-height: 304px;
      overflow: auto;
    }
  }
  .entry-exit-table-details {
    .el-table {
      max-height: 298px;
    }
  }
  .entry-exit-table,
  .entry-exit-table-details {
    padding: 20px 22px 14px 18px;
    .el-table .el-table__body-wrapper .el-table__body tr td .cell {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .nums,
    .unit-price,
    .total-price,
    .bill-total-price {
      p {
        padding-left: 16px;
        color: #333333;
        font-family: 'PingFang SC-Regular';
        font-weight: 400;
        font-size: 14px;
      }
    }
  }

  .footer {
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 0px 0px 8px 8px;
    .btn-gray {
      background-color: #F5F7FA;
      color: #999999;
      border-color: #EEEEEE;
    }
    .btn-red {
      background-color: #F56C6C;
      color: white;
      border-color: #F56C6C;
    }
  }

  
  .write-off-dialog {
    .el-dialog__header {
      padding-left: 20px;
    }
  
    .el-dialog__body {
      padding: 0px;
  
      .border {
        border-color: #EEEEEE;
        margin-bottom: 0px
      }
      .table {
        height: 280px;
        overflow-y: auto;
        padding: 20px;
      }
    }
  
    .dialog-footer {
      padding-bottom: 20px;
      border-top: 1px solid #f7f7f7;
      padding-top: 20px;
      display: flex;
      justify-content: center;
    }
  }

  
  .down-dialog {
    .border {
      margin-bottom: 20px;
    }
    .down-tmp {
      margin-bottom: 8px;
    }
    .el-icon-warning {
      font-size: 16px;
      color: #F47A25;
      margin-right: 6px;
      vertical-align: middle;
      margin-bottom: 2px;
    }
    .sub-title {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
    }
    .introduce {
      display: inline-block;
    }
    .tips {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      margin: 11px 0px 21px 0px;
    }
    .upload-tips-container {
      position: relative;
      width: 180px;
      .upload-tips-name {
        height: 30px;
        line-height: 30px;
        margin: 12px 0px;
        color: #2E68EA;
        background: #EBEEF5;
        border-radius: 2px;
        padding-left: 7px;
        box-sizing: border-box;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        .el-icon-error {
          position: absolute;
          top: -5px;
          right: -8px;
          color: #999999;
          cursor: pointer;
        }
      }
    }
    .sub-tips {
      color: #999999;
    }
    .dialog-footer {
      margin-top: 16px;
      border-top: 1px solid #f7f7f7;
      padding-top: 16px;
      display: flex;
      justify-content: center;
      .btn-white {
        margin-right: 20px;
      }
    }
  }
  
  .red-dialog {
    .border {
      margin-bottom: 10px;
    }
    .dialog-footer {
      margin-top: 20px;
      border-top: 1px solid #f7f7f7;
      padding-top: 16px;
      display: flex;
      justify-content: center;
      .btn-white {
        margin-right: 20px;
      }
    }
  }
}

.messageBox420 .el-message-box__content .el-message-box__message {
  padding-left: 0px;
}
</style>
